'use client'

import { useLookupsStore } from '@repo/store/useLookupsStore'
import MUIFormControl from '@mui/material/FormControl'
import MUIInputLabel from '@mui/material/InputLabel'
import MUIMenuItem from '@mui/material/MenuItem'
import MUISelect from '@mui/material/Select'
import { useState, useEffect } from 'react'
import type { SelectChangeEvent } from '@mui/material/Select'

const LABEL_ID = 'matter-history-type-label'

export const MatterHistoryTypeSelect = ({ value, onChange, width = '320px', sx }: MatterHistoryTypeSelectProps) => {
  const { matterHistoryTypes, fetchMatterHistoryTypes } = useLookupsStore()
  const [hasFetched, setHasFetched] = useState(false)

  useEffect(() => {
    if (!matterHistoryTypes?.length && !hasFetched) {
      setHasFetched(true)
      fetchMatterHistoryTypes()
    }
  }, [matterHistoryTypes])

  const handleChange = (e: SelectChangeEvent<string>) => {
    const v = e.target.value
    onChange(v === '' ? null : v)
  }

  return (
    <MUIFormControl sx={{ width: '100%', ...sx }} variant="outlined">
      <MUIInputLabel id={LABEL_ID}>Custom type</MUIInputLabel>
      <MUISelect
        labelId={LABEL_ID}
        label="Custom type"
        multiple={false}
        value={value ?? ''}
        onChange={handleChange}
        sx={{ width: '100%' }}
      >
        {matterHistoryTypes && matterHistoryTypes.length > 0 ? (
          matterHistoryTypes.map((type: any) => (
            <MUIMenuItem
              key={type.id}
              value={type.id}
              sx={{
                margin: '6px 6px',
                borderRadius: '4px',
                cursor: 'pointer',
                width: `calc(${width} - 20px)`
              }}
            >
              {type.name}
            </MUIMenuItem>
          ))
        ) : (
          <MUIMenuItem
            key={'no=types'}
            value={null as any}
            sx={{
              margin: '6px 6px',
              borderRadius: '4px',
              cursor: 'pointer',
              width: `calc(${width} - 20px)`
            }}
          >
            No custom types available for this matter
          </MUIMenuItem>
        )}
      </MUISelect>
    </MUIFormControl>
  )
}

type MatterHistoryTypeSelectProps = {
  value: any
  onChange: (value: any) => void
  width?: string
  feeEarners_DI?: Array<any>
  multiple?: boolean
  sx?: object
}
